"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffinityWallet = void 0;
const wallet_core_sdk_1 = require("@affinidi/wallet-core-sdk");
const affinity_metrics_lib_1 = require("@affinidi/affinity-metrics-lib");
const KeysService_1 = __importDefault(require("./services/KeysService"));
const WalletStorageService_1 = __importDefault(require("./services/WalletStorageService"));
const COMPONENT = affinity_metrics_lib_1.EventComponent.AffinidiBrowserSDK;
class AffinityWallet extends wallet_core_sdk_1.CommonNetworkMember {
    constructor(password, encryptedSeed, options = {}, component = COMPONENT) {
        super(password, encryptedSeed, options, component);
        const sdkOptions = wallet_core_sdk_1.CommonNetworkMember.setEnvironmentVarialbles(options);
        this.keysService = new KeysService_1.default(encryptedSeed, password);
        this.walletStorageService = new WalletStorageService_1.default(encryptedSeed, password, sdkOptions);
    }
    /**
     * @description Logins with access token of Cognito user registered in Affinity
     * @param options - optional parameters for AffinityWallet initialization
     * @returns initialized instance of SDK or throws `COR-9` UnprocessableEntityError,
     * if user is not logged in.
     */
    static init(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield wallet_core_sdk_1.__dangerous.ParametersValidator.validate([
                { isArray: false, type: wallet_core_sdk_1.__dangerous.SdkOptions, isRequired: false, value: options },
            ]);
            const { keyStorageUrl, userPoolId } = wallet_core_sdk_1.CommonNetworkMember.setEnvironmentVarialbles(options);
            const { accessToken } = wallet_core_sdk_1.__dangerous.readUserTokensFromSessionStorage(userPoolId);
            const encryptedSeed = yield WalletStorageService_1.default.pullEncryptedSeed(accessToken, keyStorageUrl, options);
            const encryptionKey = yield WalletStorageService_1.default.pullEncryptionKey(accessToken);
            return new AffinityWallet(encryptionKey, encryptedSeed, options);
        });
    }
    /**
     * @description Initiates sign up flow
     * @param username - arbitrary username, email or phoneNumber
     * @param password - is required if arbitrary username was provided.
     * It is optional and random one will be generated, if not provided when
     * email or phoneNumber was given as a username.
     * @param options - optional parameters with specified environment
     * @param messageParameters - optional parameters with specified welcome message
     * @returns token or, in case when arbitrary username was used, it returns
     * initialized instance of SDK
     */
    static signUp(username, password, options, messageParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const networkMember = yield wallet_core_sdk_1.CommonNetworkMember.signUp(username, password, options, messageParameters);
            if (networkMember.constructor === String) {
                return networkMember;
            }
            const { password: networkMemberPassword, encryptedSeed } = networkMember;
            return new AffinityWallet(networkMemberPassword, encryptedSeed, options);
        });
    }
    /**
     * @description Completes sign in
     * @param token - received from #signIn method
     * @param confirmationCode - OTP sent by AWS Cognito/SES
     * @param options - optional parameters for CommonNetworkMember initialization
     * @returns an object with a flag, identifying whether new account was created, and initialized instance of SDK
     */
    static confirmSignIn(token, confirmationCode, options = { issueSignupCredential: false }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield wallet_core_sdk_1.__dangerous.ParametersValidator.validate([
                { isArray: false, type: 'string', isRequired: true, value: token },
                {
                    isArray: false,
                    type: 'confirmationCode',
                    isRequired: true,
                    value: confirmationCode,
                },
                { isArray: false, type: wallet_core_sdk_1.__dangerous.SdkOptions, isRequired: false, value: options },
            ]);
            options = Object.assign({}, wallet_core_sdk_1.CommonNetworkMember.setEnvironmentVarialbles(options), options);
            let affinityWallet;
            // NOTE: loginToken = '{"ChallengeName":"CUSTOM_CHALLENGE","Session":"...","ChallengeParameters":{"USERNAME":"...","email":"..."}}'
            //       signUpToken = 'username::password'
            const isSignUpToken = token.split('::')[1] !== undefined;
            if (isSignUpToken) {
                affinityWallet = yield this.confirmSignUp(token, confirmationCode, options);
                return { isNew: true, commonNetworkMember: affinityWallet };
            }
            const parentWallet = yield this.completeLoginChallenge(token, confirmationCode, options);
            // affinityWallet = await AffinityWallet.init(options)
            const { password, encryptedSeed } = parentWallet;
            const cognitoUserTokens = parentWallet.cognitoUserTokens;
            options.cognitoUserTokens = cognitoUserTokens;
            affinityWallet = new AffinityWallet(password, encryptedSeed, options);
            return { isNew: false, commonNetworkMember: affinityWallet };
        });
    }
    /**
     * @description Completes sign up flow with optional VC issuance using sign up info
     * @param token - received from #signUp method
     * @param confirmationCode - OTP sent by AWS Cognito/SES.
     * NOTE: is not required if email or phoneNumber was given on #signUp.
     * @param options - optional parameters for CommonNetworkMember initialization
     * @returns initialized instance of SDK
     */
    static confirmSignUp(token, confirmationCode, options = { issueSignupCredential: false }) {
        const _super = Object.create(null, {
            confirmSignUp: { get: () => super.confirmSignUp }
        });
        return __awaiter(this, void 0, void 0, function* () {
            options = Object.assign({}, wallet_core_sdk_1.CommonNetworkMember.setEnvironmentVarialbles(options), options);
            const networkMember = yield _super.confirmSignUp.call(this, token, confirmationCode, options);
            const { idToken } = networkMember.cognitoUserTokens;
            const { password, encryptedSeed } = networkMember;
            options.cognitoUserTokens = networkMember.cognitoUserTokens;
            const affinityWallet = new AffinityWallet(password, encryptedSeed, options);
            if (options.issueSignupCredential) {
                const signedCredentials = yield affinityWallet.getSignupCredentials(idToken, options);
                yield affinityWallet.saveCredentials(signedCredentials);
            }
            return affinityWallet;
        });
    }
    /**
     * @description Creates encrypted message for another user DID
     * 1. resolve DID (for whom message will be encrypted)
     * 2. get public key from resolved DID document
     * 3. encrypt message using public key of resolved DID
     * @param did - DID of user for whom message will be sent (only this user
     * will be able to decrypt it using his private key),
     * or if DID Document is passed, resolveDid won't happen
     * @param object - message object which will be send
     * @returns encryptedMessage - string version of encrypted message
     */
    createEncryptedMessage(did, object) {
        return __awaiter(this, void 0, void 0, function* () {
            let didDocument = did;
            if (typeof did === 'string') {
                didDocument = yield this.resolveDid(did);
            }
            const publicKeyHex = this.getPublicKeyHexFromDidDocument(didDocument);
            return this.keysService.encryptByPublicKey(publicKeyHex, object);
        });
    }
    /**
     * @description Decrypts message using user's private key
     * @param encryptedMessage - message encrypted for you by your public key
     * @returns decrypted message
     */
    readEncryptedMessage(encryptedMessage) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.keysService.decryptByPrivateKey(encryptedMessage);
        });
    }
    /**
     * @description Save's encrypted VCs in Affinity Guardian Wallet
     * 1. encrypt VCs
     * 2. store encrypted VCs in Affinity Guardian Wallet
     * @param data - array of VCs
     * @param storageRegion - (optional) specify AWS region where credentials will be stored
     * @returns array of ids for corelated records
     */
    saveCredentials(data, storageRegion) {
        return __awaiter(this, void 0, void 0, function* () {
            const encryptedCredentials = yield this.walletStorageService.encryptCredentials(data);
            const result = yield this.saveEncryptedCredentials(encryptedCredentials, storageRegion);
            this._sendVCSavedMetrics(data);
            // NOTE: what if creds actually were not saved in the vault?
            //       follow up with Isaak/Dustin on this - should we parse the response
            //       to define if we need to send the metrics
            return result;
        });
    }
    /**
     * @description Retrieve only the credential at given index
     * @param credentialIndex - index for the VC in vault
     * @returns a single VC
     */
    getCredentialByIndex(credentialIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const paginationOptions = { skip: credentialIndex, limit: 1 };
            const blobs = yield this.walletStorageService.fetchEncryptedCredentials(paginationOptions);
            if (blobs.length < 1) {
                throw new wallet_core_sdk_1.__dangerous.SdkError('COR-14');
            }
            const decryptedCredentials = yield this.walletStorageService.decryptCredentials(blobs);
            return decryptedCredentials[0];
        });
    }
    /**
     * @description Finds the given credentialShareRequestToken by searching all of your credentials
     * If a token is not given, only returns the given subset of the credentials
     * 1. pull encrypted VCs (all if token given, otherwise with the given pagination)
     * 2. decrypt encrypted VCs
     * 3. filter VCs by type
     * @param credentialShareRequestToken - JWT received from verifier
     * @param paginationOptions - optional range for credentials to be pulled (default is skip: 0, limit: 100)
     * @returns array of VCs
     */
    getCredentials(credentialShareRequestToken = null, paginationOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (credentialShareRequestToken) {
                return this._getCredentialsWithCredentialShareRequestToken(credentialShareRequestToken);
            }
            let blobs;
            try {
                blobs = yield this.walletStorageService.fetchEncryptedCredentials(paginationOptions);
            }
            catch (error) {
                if (error.code === 'COR-14') {
                    return [];
                }
                else {
                    throw error;
                }
            }
            if (blobs.length === 0) {
                return [];
            }
            return this.walletStorageService.decryptCredentials(blobs);
        });
    }
    _getCredentialsWithCredentialShareRequestToken(credentialShareRequestToken) {
        var e_1, _a;
        return __awaiter(this, void 0, void 0, function* () {
            let result = [];
            try {
                for (var _b = __asyncValues(this.walletStorageService.fetchAllEncryptedCredentialsInBatches()), _c; _c = yield _b.next(), !_c.done;) {
                    const blobs = _c.value;
                    const credentials = yield this.walletStorageService.decryptCredentials(blobs);
                    const matchedCredentials = this.walletStorageService.filterCredentials(credentialShareRequestToken, credentials);
                    result = result.concat(matchedCredentials);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) yield _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return result;
        });
    }
    /**
     * @description Delete credential by id if found in given range
     * @param id - id of the credential
     * @param credentialIndex - credential to remove
     */
    deleteCredential(id, credentialIndex) {
        var e_2, _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((credentialIndex !== undefined && id) || (!id && credentialIndex === undefined)) {
                throw new wallet_core_sdk_1.__dangerous.SdkError('COR-1', {
                    errors: [{ message: 'should pass either id or credentialIndex and not both at the same time' }],
                });
            }
            if (credentialIndex) {
                return this.deleteCredentialByIndex(credentialIndex.toString());
            }
            let allBlobs = [];
            try {
                for (var _b = __asyncValues(this.walletStorageService.fetchAllEncryptedCredentialsInBatches()), _c; _c = yield _b.next(), !_c.done;) {
                    const blobs = _c.value;
                    allBlobs = allBlobs.concat(blobs);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) yield _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            yield this.walletStorageService.decryptCredentials(allBlobs);
            const credentialIndexToDelete = this.walletStorageService.findCredentialIndexById(id);
            return this.deleteCredentialByIndex(credentialIndexToDelete);
        });
    }
}
exports.AffinityWallet = AffinityWallet;
//# sourceMappingURL=AffinityWallet.js.map